/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class ProjectProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Project by ID
	 * @param {String|Number} pProjectID - The Project ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getProjectByID(pProjectID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pProjectID)
			{
				this.pict.log.error('No Project ID provided.');
				return reject(new Error('No Project ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Project/${pProjectID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Project: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the Projects
	 * @param {string} pCustomerID - The Customer ID to search for
	 * @return {Promise<void>}
	 * @async
	 * @example
	 */
	getProjects(pCustomerID)
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'Projects';

			// Filter by customer ID if provided
			if (pCustomerID)
			{
				tmpURL = `Projects/By/IDCustomer/${pCustomerID}`;
			}

			// Make the API call
			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get Projects list.', pError);
					return reject(pError); // Reject the promise in case of error
				}
				resolve(pBody); // Resolve with the retrieved data
			});
		});
	}
}

module.exports = ProjectProvider;
module.exports.default_configuration = {};
